<script>
	import { onMount } from "svelte";

	let FaComponent;
	let loadPromise;

	const loadFa = async () => {
		if (FaComponent) return FaComponent;
		loadPromise = loadPromise ?? import("svelte-fa");
		const module = await loadPromise;
		FaComponent = module.default;
		return FaComponent;
	};

	onMount(async () => {
		await loadFa();
	});
</script>

{#if FaComponent}
	<svelte:component this={FaComponent} {...$$restProps} />
{/if}
